import React from "react";
import Styled from "./styled";

const FooterDescription: React.FC = () => {
    return (
        <Styled>
            G.O.A.L. (Giovani Orientamento Autoderminazione Lavoro)
            <br />
            Numero Progetto 2016-ADR-00186 Co-finanziato da Impresa Sociale con i bambini
        </Styled>
    );
};

export default FooterDescription;
